import { useParams } from '@tanstack/react-router'
import { RegulatoryRequestWorkView } from './components/RegulatoryRequestWorkView'

/**
 * Full-page per-request working view, shared by both regulatory sibling
 * modules (regulatory-customer / regulatory-vendor). Each module's page
 * file is a thin re-export wrapper around this. Reads `requestId` from the
 * route param; the work view derives the correct back-link board from the
 * request's `request_type`.
 */
export function RegulatoryRequestPage() {
  const params = useParams({ strict: false }) as { requestId?: string }
  const requestId = params.requestId
  if (!requestId) {
    return <div className="p-8 text-tertiary">Invalid request id.</div>
  }
  return <RegulatoryRequestWorkView requestId={requestId} />
}
